/*
  Holds back the reveal for anything below the fold until it scrolls into view -- the
  second half of assets/orbit-motion.css, and the same behaviour as Dawn's animations.js
  that deathwishcoffee.com runs.

  The targets are not listed here. By the time this runs, every target on the page is
  already playing one of the two reveal animations (the stylesheet starts them from first
  paint), so they are collected from document.getAnimations(). The stylesheet stays the
  one place a target is named, and a new one never has to be added in two files.

  Each target is observed once. One that is not on screen gets data-orbit-offscreen, which
  drops the animation and holds it at its start frame; when it comes into view the
  attribute goes and the stylesheet plays the animation again from the top. Items that
  arrive together are numbered in arrival order, so a row revealed by scrolling staggers
  left to right the same way a row that was on screen at load does.
*/
(() => {
  const html = document.documentElement;
  if (!html.classList.contains('orbit-motion') || !('IntersectionObserver' in window)) return;
  if (typeof document.getAnimations !== 'function') return;

  const NAMES = new Set(['orbit-slide-in', 'orbit-fade-in']);
  const OFFSCREEN = 'data-orbit-offscreen';

  const targets = new Set();
  for (const animation of document.getAnimations()) {
    const target = animation.effect && animation.effect.target;
    if (target && NAMES.has(animation.animationName)) targets.add(target);
  }
  if (targets.size === 0) return;

  const staggers = (element) => getComputedStyle(element).getPropertyValue('--orbit-stagger').trim() === '1';

  const observer = new IntersectionObserver(
    (entries) => {
      let order = 0;
      for (const entry of entries) {
        const element = entry.target;
        if (entry.isIntersecting) {
          if (element.hasAttribute(OFFSCREEN)) {
            if (staggers(element)) element.style.setProperty('--orbit-order', String(order++));
            element.removeAttribute(OFFSCREEN);
          }
          observer.unobserve(element);
        } else {
          element.setAttribute(OFFSCREEN, '');
        }
      }
    },
    // Dawn's margin: an element has to be 50px inside the viewport before it moves, so it
    // is never revealed while it is still sitting under the bottom edge.
    { rootMargin: '0px 0px -50px 0px' }
  );

  targets.forEach((element) => observer.observe(element));
})();
